import React from "react";
import { Box, Typography, useTheme, Container, Skeleton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";

import GymPolicy from "./GymPolicy";
import GymSlider from "./GymSlider";

const GymsSct = ({ gymsData, gymsStatus }) => {
  const navigate = useNavigate();
  const theme = useTheme();

  const isLoading = gymsStatus === "pending";

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        bgcolor: "background.default",
        py: { xs: 4, md: 6 },
        pb: "5rem !important",
        px: { xs: 2, sm: 3, md: 4 },
      }}
    >
      <Container maxWidth={"xxl"}>
        {/* Header Section */}
        <Box sx={{ mb: 4 }}>
          <Typography
            onClick={() => navigate("/gyms")}
            variant="h6"
            sx={{
              fontWeight: 800,
              background: `linear-gradient(45deg, ${theme.palette.primary.main} 30%, ${theme.palette.primary.light} 90%)`,
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              mb: 1,
              cursor: "pointer",
            }}
          >
            باشگاه های پیشنهادی
          </Typography>
          <Typography variant="body2" color="text.secondary">
            بهترین باشگاه های پیشنهادی طبق آنالیز شما
          </Typography>
        </Box>

        {/* Gym Slider or Skeleton */}
        {isLoading ? (
          <Box sx={{ display: "flex", gap: 3, overflow: "hidden", mb: 4 }}>
            {[1, 2, 3, 4].map((item) => (
              <Box
                key={item}
                sx={{ width: { xs: 280, md: 320 }, flexShrink: 0 }}
              >
                <Skeleton
                  variant="rectangular"
                  height={220}
                  sx={{ borderRadius: 3 }}
                />
                <Skeleton
                  variant="text"
                  sx={{ mt: 2, fontSize: "1.5rem" }}
                  width="80%"
                />
                <Skeleton
                  variant="text"
                  sx={{ fontSize: "1rem" }}
                  width="60%"
                />
              </Box>
            ))}
          </Box>
        ) : (
          <GymSlider gymsData={gymsData} />
        )}

        {/* Gym Policies */}
        <GymPolicy />
      </Container>
    </Box>
  );
};

export default GymsSct;
